export default {
    namespace: 'baseApp',
    localeMap: {
        en: 'en-us',
        es: 'es-es',
        it: 'it-it',
        de: 'de-de',
        nl: 'nl-nl',
        fr: 'fr-fr',
    },
    currencyMap: {
        'de-de': 'EUR',
        'en-ca': 'CAD',
        'en-gb': 'GBP',
        'en-ie': 'EUR',
        'en-us': 'USD',
        'es-mx': 'MXN',
        'es-es': 'EUR',
        'it-it': 'EUR',
        'fr-ca': 'CAD',
        'fr-fr': 'EUR',
        'nl-nl': 'EUR',
    },
    supportedLocales: [
        'de-de',
        'en-ca',
        'en-gb',
        'en-us',
        'es-es',
        'es-mx',
        'fr-ca',
        'fr-fr',
        'it-it',
        'nl-nl',
    ],
    supportedCurrencies: [
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HRK',
        'HUF',
        'MXN',
        'NOK',
        'PLN',
        'RON',
        'SEK',
        'TRY',
        'USD',
    ],
    defaultLocale: 'en-us',
    defaultCurrency: 'USD',
};
